import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class NotifyService {
  toast:any;
  defaults:any={
    duration: 2000,
    position:'bottom'
  }
  constructor(public toastController: ToastController) { }
  async notify(type:string,message:string,duration:number=2000) {
    const options = {...this.defaults,...{message,duration}};
    const color = type == 'error' ? 'danger' : type == 'warn' ? 'warning' : type == 'info' ? 'tertiary' : type == 'success' ? 'success' : null;
    if(color !== null){
      options.color = color;
    }
    if(this.toast){
      await this.toast.dismiss();
    }
    this.toast = await this.toastController.create(options);
    this.toast.present();
 }
 async error( message:string, duration:number=2000){
   this.notify( 'error', message, duration);
 }
 async warn( message:string, duration:number=2000){
   this.notify( 'warning', message, duration);
 }
 async info( message:string, duration:number=2000){
   this.notify( 'info', message, duration);
 }
 async log( message:string, duration:number=2000){
   this.notify( 'default', message, duration);
 }

}
